import styled from 'styled-components'

import { Style } from '../../manageImagesModal.types'
import ProductImages from './components/ProductImages/ProductImages'
import StyleColors from './components/StyleColors/StyleColors'
import StyleInfo from './components/StyleInfo/StyleInfo'

const StyleDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
`

type StyleDataProps = {
  style: Style
}

const StyleData = ({ style }: StyleDataProps): JSX.Element => (
  <StyleDataContainer>
    <StyleInfo style={style} />
    <StyleColors />
    <ProductImages />
  </StyleDataContainer>
)

export default StyleData
